import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth2 } from "@/api/auth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const omnisearchRequests = {
  answerOmnisearch: function (omnisearchQuestion) {
    return httpAuth2
      .post("/v1/search/omnisearch_answer", {
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: omnisearchQuestion,
      })
      .json();
  },

  fetch_provider_schedule_call_list: function ({ context } = {}) {
    return httpAuth2
      .post("/v1/search/omnisearch_questions", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },
};
